<template>
  <f7-page class="div-frmPaletizadoInicio">
    <div class="menu">
      <PCSideNavbar />
    </div>
    <f7-row>
      <f7-col
        width="90"
        style="margin-left: 125px;"
      >
        <f7-row style="max-height: 70px; height: 70px;">
          <f7-col
            width="25"
            style="max-width: 250px; margin-top: 18px; border-right: 1px solid rgb(151 151 151 / 30%);"
          >
            <span v-if="logoApp">
              <img
                id="logo"
                alt="logoEmpresa"
                class="logo-empresa-frmTablet"
                :src="logoApp"
              >
            </span>
            <span v-else>
              <img
                id="logo"
                alt="logoEmpresa"
                class="logo-empresa-frmTablet"
                :src="LOGO_HISPATEC"
              >
            </span>
          </f7-col>
          <f7-col
            width="50"
            class="temp-padding-top"
          >
            <!-- <UCLineasDeProduccion
              :valor-por-defecto="lineaSeleccionadaAlIniciarFormulario"
              :deshabilitar-controles-de-avance-y-retroceso="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
              plantilla="P2"
              :mostrar-titulo="false"
              @lineaProduccionSeleccionada="LineaProduccionSeleccionada"
            /> -->
            <UCSearchEntityERP
              :placeholder="$t('common.productionLine')"
              :search-text="$t('searchEntity.line.searchText')"
              :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
              :default-value="lineaSeleccionadaAlIniciarFormulario"
              :default-etities-list="lineasProduccion"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :min-text-search="0"
              :next-and-previous-buttons-shown="true"
              :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :emit-evet-change-default-value="true"
              @selection="LineaProduccionSeleccionada"
            />
          </f7-col>
          <f7-col
            width="25"
            class="div-logoHispatecDerecha"
          >
            <img
              id="logo"
              alt="logoHispatec"
              class="img-logoHispatec"
              :src="LOGO_HISPATEC"
            >
          </f7-col>
        </f7-row>
        <!----  Boton para cambiar de completos a pendientes -->
        <f7-row class="row-cabeceraOpcionesFrm">
          <div
            class="div-selectorJornada"
          >
            <span class=""><UCDatePicker
              :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
              @onchange="CambiarFechaJornadaConsulta"
            /></span>
          </div>
          <div
            class="div-btnCambioPedidosPendientesFinalizados seleccionable"
            @click="AbrirFormularioDePedidosPendientes()"
          >
            <span class="">PENDIENTES</span>
          </div>
        </f7-row>
        <f7-row style="margin-top: 30px;">
          <UCPreload
            :show="mostrarPrecarga"
            style="width: 100%;"
          />
          <f7-col
            v-if="!mostrarPrecarga"
            width="100"
          >
            <div
              v-for="pedido in listadoPedidosPlanificados"
              :key="pedido.IdLineaPedidoVenta"
              class="ElementoPedido"
            >
              <f7-row style="margin-top: 30px;">
                <f7-col
                  width="90"
                  style="padding-left: 30px;"
                >
                  <f7-row style="margin-top: 10px;">
                    <f7-col
                      width="10"
                      class="HoraPrevista"
                    >
                      <span>-</span>
                    </f7-col>
                    <f7-col
                      width="70"
                      class="titulo-almacen"
                    >
                      <span> {{ `${pedido.Pedido} → ${pedido.NombreCompleto}` }} </span>
                    </f7-col>
                    <f7-col
                      v-if="!usarRepartoDeTrabajadoresLineaProduccionProporcional"
                      width="5"
                    >
                      <!-- Permite editar los intervalos anteriores -->
                      <div
                        class="div-indicadorNumeroTrabajadoresLineaPedido"
                        @click="EditarNumeroTrabajadoresLineaPedidoFinalizada(pedido)"
                      >
                        <img
                          align="right"
                          alt="iconTrabajador"
                          src="@/static/icons/ic_workers_yellow_indicator.svg"
                          class="seleccionable"
                        >

                        <!-- Partes Finalizados siempre debería ser 0 trabajadores -->
                        <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
                        <span class="span-indicadorNumeroTrabajadores"> 0 </span>
                      </div>
                    </f7-col>
                    <f7-col
                      width="15"
                      class=""
                    >
                      <div
                        v-if="pedido.FechaInicio != null"
                        class="div-rectanguloCompletado"
                      >
                        <span>COMPLETADO</span>
                      </div>
                      <img
                        align="right"
                        alt="iconSetting"
                        src="@/static/icons/ic_options_dark.svg"
                        class="seleccionable"
                        @click="MostrarDetalleLineaPedidoPlanificado(pedido)"
                      >
                    </f7-col>
                  </f7-row>
                  <f7-row style="margin-top: 10px;">
                    <f7-col width="100">
                      <span class="ProductoPedido">{{ `${pedido.Producto} →` }}</span>
                      <span class="ProductoPedidoGris">{{ pedido.Envase }}</span>
                    </f7-col>
                  </f7-row>
                  <f7-row style="margin-top: 10px;">
                    <f7-col
                      class="oval"
                      @click="SolicitarEliminarFechaFinCostesPedido(pedido, false)"
                    >
                      <img
                        alt="iconOkey"
                        src="@/static/icons/ic_check_03.svg"
                      >
                    </f7-col>
                    <f7-col
                      width="90"
                      class="progresoPedido"
                    >
                      <div class="progresoPedidoPrevisto" />
                      <div
                        class="progresoPedidoReal progresoPedidoRealVerde"
                        :style="{ width: `${pedido.Porcentaje}%` }"
                      />
                    </f7-col>
                  </f7-row>
                </f7-col>
                <f7-col
                  width="10"
                  style="margin-top: 17px; padding-right: 30px;"
                >
                  <f7-row class="elementoCantidades">
                    <span class="CantidadKilos">{{ pedido.PesoNeto }}</span>
                    <span class="labelCantidad">
                      {{ $t('common.kilos').toUpperCase() }}
                    </span>
                  </f7-row>
                  <f7-row class="elementoCantidades">
                    <span class="CantidadPalets">{{ `${pedido.CantidadReservada} ${$t('common.of')} ${pedido.CantidadPalet}` }}</span>
                    <span class="labelCantidad">{{ $t('common.pallets').toUpperCase() }}</span>
                  </f7-row>
                  <f7-row class="elementoCantidades">
                    <span class="CantidadPalets">{{ `${pedido.CantidadEnvase} ${$t('common.of')} ${pedido.CantidadEnvase}` }}</span>
                    <span class="labelCantidad">{{ $t('common.packages').toUpperCase() }}</span>
                  </f7-row>
                </f7-col>
              </f7-row>
            </div>
          </f7-col>
        </f7-row>
      </f7-col>
    </f7-row>

    <!-- Popup DetallePedidoSeleccionadoAbierto -->
    <f7-popup
      class="edicionPedidoPlanificado-popup"
      :opened="popupDetallePedidoSeleccionadoAbierto"
      @popup:closed="popupDetallePedidoSeleccionadoAbierto = false"
    >
      <TheNavbar
        sliding
        :nav-title="$t('production.common.salesOrderDetail')"
        :popup-close-btn-enable="true"
        :style="appTheme"
      />
      <div
        v-if="pedidoSeleccionado != null"
        class="div-frmDetalleLineaPedido"
      >
        <PCDetalleLineaPedidoVenta
          :pedido-seleccionado="pedidoSeleccionado"
          :elementos-mostrar="[
            'DireccionDeEnvio',
            'ObservacionesPedidoVenta',
            'ObservacionesLineaPedidoVenta',
            'ObservacionesPorte',
            'ReferenciaPedidoVenta',
            'Lote',
            'UbicacionPalesProducidos',
            'FechaSalida',
          ]"
        />
      </div>
    </f7-popup>

    <!-- Popup Detalle Trabajadores por parte de produccion -->
    <f7-popup
      class="detalleTrabajadoresParte-popup"
      :opened="popupDetalleTrabajadoresParteProduccionAbierto"
      @popup:closed="popupDetalleTrabajadoresParteProduccionAbierto = false"
    >
      <TheNavbar
        sliding
        :nav-title="$t('TrabajadoresDelParteProduccion')"
        :popup-close-btn-enable="true"
        :style="appTheme"
      />
      <div v-if="pedidoSeleccionado != null">
        <PCParteProduccionNumeroTrabajadores
          id-componente="trabajadores-parte-produccion"
          :linea-produccion-seleccionada="lineaSeleccionada"
          :linea-pedido-venta-seleccionada="pedidoSeleccionado.LineaPedidoVenta"
          :parte-produccion="pedidoSeleccionado.ParteProduccion"
          :activo="popupDetalleTrabajadoresParteProduccionAbierto"
          :habilitar-edicion="!usarRepartoDeTrabajadoresLineaProduccionProporcional"
          @confirmar="popupDetalleTrabajadoresParteProduccionAbierto = false"
          @cancelar="popupDetalleTrabajadoresParteProduccionAbierto = false"
        />
      </div>
    </f7-popup>

    <UCConfirmation
      ref="UCConfirmation"
      :continue="$t('common.continue')"
    />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import TheNavbar from '@/components/TheNavbar.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { sleep } from '@/js/utils/sleep';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import PCDetalleLineaPedidoVenta from '@/components/production/traceability/PCDetalleLineaPedidoVenta.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import PCParteProduccionNumeroTrabajadores from '@/components/production/productionLinesManagement/PCParteProduccionNumeroTrabajadores.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';
import { LOGO_HISPATEC } from '@/js/common/constants';
import { f7 } from 'framework7-vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';

export default {
  name: 'FrmProductionPlanningStatusComplete',
  components: {
    TheNavbar,
    PCSideNavbar,
    PCDetalleLineaPedidoVenta,
    UCDatePicker,
    PCParteProduccionNumeroTrabajadores,
    UCPreload,
    UCSearchEntityERP,
    UCConfirmation,
  },

  data() {
    return {
      lineaSeleccionada: null, // Mantiene la linea seleccionada.
      puntosDePaletizado: null, // Mantiene los puntos de paletizado de la linea de produccion selecctionada.
      listadoPedidosPlanificados: null, // Mantiene los pedidos planificados.
      mostrarPrecarga: false,
      lineaSeleccionadaAlIniciarFormulario: null,
      pedidoSeleccionado: null,
      popupDetallePedidoSeleccionadoAbierto: false,
      jornadaConsulta: null,
      popupDetalleTrabajadoresParteProduccionAbierto: false,
      contadorDeLlamadasPendientesDeRespuestaEnFrm: 0, // Controla el número de llamadas al WS que se estan realizando en el frm sin respuesta.
      lineasProduccion: null,
      LOGO_HISPATEC,
      usarRepartoDeTrabajadoresLineaProduccionProporcional: useParamRef('NumeroTrabajadoresManualLineasProduccionLineaPedido'),
      logoApp: useSettingRef('App.Logo'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineaDeProduccionSeleccionada',
      'lineasDeProduccionDelUsuarioDefinidaEnERP',
      'getLineasProduccion',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  mounted() {
    this.IncializarFrm();
  },

  methods: {
    onDrop() {
      Log(this, this.onDrop.name);
    },
    IncializarFrm() {
      Log(this, this.IncializarFrm.name);
      this.jornadaConsulta = SoporteFechaYHora.obtenerDDMMAA(Date());
      // Sol.221815  - Cuando salgo para volcar y vuelvo a entrar en el paletizado, debe seguir cargada la última línea que estuvo seleccionada.
      this.lineaSeleccionadaAlIniciarFormulario = this.lineaDeProduccionSeleccionada;
      // sol.222038 - Si lineaSeleccionadaAlIniciarFormulario es null obtenemos la linea por defecto definida en el trabajador.
      this.lineaSeleccionadaAlIniciarFormulario ??= this.lineasDeProduccionDelUsuarioDefinidaEnERP;
      this.lineasProduccion = this.getLineasProduccion;
    },

    LineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.LineaProduccionSeleccionada.name);
      this.lineaSeleccionada = lineaSeleccionada;
      if (lineaSeleccionada == null) {
        this.puntosDePaletizado = null;
        return;
      }
      this.puntosDePaletizado = this.lineaSeleccionada.PuntosDePaletizado;
      this.ObtenerPedidosCompletosLinea(this.jornadaConsulta);
    },

    MostrarDetalleLineaPedidoPlanificado(pLineaPedidoSeleccionada) {
      Log(this, this.MostrarDetalleLineaPedidoPlanificado.name);
      this.LineaPedidoPlanificadoSeleccionado(pLineaPedidoSeleccionada);
      this.popupDetallePedidoSeleccionadoAbierto = true;
    },

    EditarNumeroTrabajadoresLineaPedidoFinalizada(pLineaPedidoActiva) {
      Log(this, this.EditarNumeroTrabajadoresLineaPedidoFinalizada.name);
      this.LineaPedidoPlanificadoSeleccionado(pLineaPedidoActiva);
      this.popupDetalleTrabajadoresParteProduccionAbierto = true;
    },

    LineaPedidoPlanificadoSeleccionado(lineaPedidoEnProduccion) {
      Log(this, this.LineaPedidoPlanificadoSeleccionado.name);
      // Mapeamos los datos con la estructura necesaria para que funcionen el resto de componentes
      this.pedidoSeleccionado = {
        ParteProduccion: {
          Id: lineaPedidoEnProduccion.Id_ParteProduccion,
          Serie: lineaPedidoEnProduccion.SerieParteProduccion,
          Numero: lineaPedidoEnProduccion.NumeroParteProduccion,
          ParteProduccionReal: {
            Id: lineaPedidoEnProduccion.IdParteProduccionReal,
          },
        },
        LineaPedidoVenta: {
          Id: lineaPedidoEnProduccion.IdLineaPedidoVenta,
          PedidoVenta: {
            Id: lineaPedidoEnProduccion.Id_PedidoVenta,
          },
        },
        DireccionDeEnvio: lineaPedidoEnProduccion.DireccionEnvio,
        PuntoPaletizado: {
          UbicacionPalesProducidos: null,
        },
        Lote: {
          Codigo: lineaPedidoEnProduccion.CodigoLote,
        },
        ReferenciaPedidoVenta: lineaPedidoEnProduccion.Referencia,
        ObservacionesPedidoVenta: {
          Texto: lineaPedidoEnProduccion.ObservacionesCabecera,
        },
        ObservacionesLineaPedidoVenta: {
          Texto: lineaPedidoEnProduccion.ObservacionesLinea,
        },
      };
    },
    ObtenerPedidosCompletosLinea(pJornada) {
      Log(this, this.ObtenerPedidosCompletosLinea.name);
      if (!this.lineaSeleccionada) {
        return;
      }

      const self = this;
      self.mostrarPrecarga = true;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      ConexionTA.callObtenerPedidosCompletosLineaProduccionXJornada(this.lineaSeleccionada.Id, pJornada)
        .then((result) => {
          if (result.Valor) {
            self.listadoPedidosPlanificados = JSON.parse(result.Mensaje);
            self.mostrarPrecarga = false;
          } else {
            self.listadoPedidosPlanificados = null;
            HiNotification.Toast(result.Mensaje);
            self.mostrarPrecarga = false;
          }
        })
        .catch((error) => {
          self.mostrarPrecarga = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },
    /*  Método SolicitarEliminarFechaFinCostesPedido * */
    SolicitarEliminarFechaFinCostesPedido(pedido, confirmacion) {
      Log(this, this.SolicitarEliminarFechaFinCostesPedido.name);
      this.pedidoSeleccionado = pedido;
      // Mensaje de confirmación.
      if (!confirmacion) {
        this.$refs.UCConfirmation.create(
          this.$t('production.common.reopenSalesOrder').toUpperCase(),
          this.$t('production.common.doYouWantToReopenOrder'),
          () => {
            this.SolicitarEliminarFechaFinCostesPedido(this.pedidoSeleccionado, true);
          },
        );
        this.$refs.UCConfirmation.show();
        return;
      }
      // Retardo evitar error dialog
      sleep(10).then(() => {
        this.EliminarFechaFnDeCostesPedido(pedido);
      });
    },
    /*  Método EliminarFechaFinCostesPedido * */
    EliminarFechaFnDeCostesPedido(pedido) {
      Log(this, this.EliminarFechaFnDeCostesPedido.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      ConexionTA.callEliminarFechaFinCostesPedido(pedido.IdParteProduccionReal)
        .then((result) => {
          if (result.Valor) {
            HiNotification.Toast(result.Mensaje);
          } else {
            HiNotification.Toast(result.Mensaje);
          }
          self.ObtenerPedidosCompletosLinea(this.jornadaConsulta);
        })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        }).finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },

    /*  Método AbrirFormularioDePedidosPendientes * */
    AbrirFormularioDePedidosPendientes() {
      Log(this, this.AbrirFormularioDePedidosPendientes.name);
      // if (!comprobarAutorizacionDeAccesoDelUsuario('EP', true)) return;
      f7.views.main.router.navigate('/production/roductionLines/productionLinesManagement/FrmProductionPlanningStatus', {
        reloadCurrent: true,
        reloadPrevious: true,
        pushState: false,
      });
      window.screen.orientation.lock('landscape');
    },
    /*  Método CambiarFechaJornadaConsulta * */
    CambiarFechaJornadaConsulta(pFecha) {
      Log(this, this.CambiarFechaJornadaConsulta.name);
      this.jornadaConsulta = SoporteFechaYHora.obtenerDDMMAA(pFecha);
      this.ObtenerPedidosCompletosLinea(this.jornadaConsulta);
    },
  },

};
</script>

<style scoped lang="scss">
.page {
  // TODO: Remove when migrated to new styles
  --f7-grid-row-gap: 0;
  //

  background-color: #f7f7f7;
  --information-bar-padding-bottom: 0;
}

.titulo-almacen {
  color: var(--his-steel-blue);
  font-size: 24px;
  font-weight: 500;
  line-height: 29px;
  text-align: left;
}

.titulo-almacen-centro {
  color: var(--his-plum-shadow);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.selector-lineaproduccion {
  background-color: rgb(9 30 66 / 4%);
  border: 1px solid rgb(9 30 66 / 25%);
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgb(9 30 66 / 4%);
  height: 58px;
}

.selector-lineaproduccion-textolinea {
  color: var(--his-steel-blue);
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  vertical-align: middle;
  padding-top: 15px;
  padding-left: 16px;
}

.selector-lineaproduccion-navegacion {
  background-color: var(--his-steel-blue);
  border-radius: 8px;
  width: 58px;
  height: 58px;
  max-width: 58px;
  max-height: 58px;
}

.ElementoPedido {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
  height: 225px;
  margin-right: 30px;
  margin-top: 15px;
  min-height: 200px;
}

.HoraPrevista {
  display: flex;
  justify-content: center;
  background-color: rgb(122 134 154 / 20%);
  border-radius: 14px;
  max-width: 76px;
  min-width: 76px;
  height: 28px;
  text-align: center;
}

.HoraPrevista span {
  display: flex;
  align-items: center;
  color: var(--his-steel-blue);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 17px;
  text-align: center;
}

.ProductoPedido {
  color: var(--his-steel-blue);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 24px;
  text-align: left;
}

.ProductoPedidoGris {
  color: var(--his-kiwi-pulp);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 24px;
  text-align: left;
}

.progresoPedido {
  background-color: #f4f5f7;
  border-radius: 100px;
  height: 80px;
}

.progresoPedidoPrevisto {
  background-color: var(--his-kiwi-pulp);
  opacity: 0.3208372201492538;
  border-radius: 100px;
  width: 366px;
  height: 80px;
}

.progresoPedidoReal {
  position: relative;
  background-color: var(--his-mandarina);
  border-radius: 100px;
  opacity: 1;
  height: 80px;
  top: -80px;
}

.progresoPedidoRealVerde {
  background-color: var(--his-greenlight);
  min-width: 80px;
}

.oval {
  max-width: 88px;
  min-width: 88px;
}

.CantidadKilos {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 34px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 41px;
  text-align: right;
}

.labelCantidad {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 17px;
  opacity: 0.5017206101190477;
  text-align: right;
}

.CantidadPalets {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 22px;
  text-align: right;
}

.elementoCantidades {
  margin-bottom: 15px;
}

.span-tituloColumnas {
  color: var(--his-plum-shadow);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.div-contenido {
  margin-left: 100px;
  margin-right: 10px;
}

.menu {
  background-color: #ebecf0;
  box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
  width: 80px;
  height: 100vh;
  float: left;
}

.div-rectanguloCompletado {
  background-color: var(--his-greenlight);
  border-radius: 3px;
  width: 93px;
  height: 19px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  padding-bottom: 5px;
}

.div-rectanguloCompletado span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.div-logoHispatecDerecha {
  max-width: 250px;
  margin-top: 18px;
  border-left: 1px solid rgb(151 151 151 / 30%);
  text-align: end;
  padding-right: 15px;
}

.div-btnCambioPedidosPendientesFinalizados {
  background-color: rgb(172 160 149 / 20%);
  border: 1px solid var(--his-kiwi-pulp);
  border-radius: 8px;
  width: 184px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  /* float: right; */
  margin-right: 30px;
}

.div-btnCambioPedidosPendientesFinalizados span {
  color: var(--his-kiwi-pulp);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.26px;
  line-height: 22px;
  text-align: left;
}

.row-cabeceraOpcionesFrm {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.img-logoHispatec {
  padding-left: 45px;
}

.div-selectorJornada {
  margin-top: 10px;
  margin-right: 20px;
}

.span-indicadorNumeroTrabajadores {
  font-size: 25px;
  color: #fff;
  position: fixed;
  margin-top: 17px;
  margin-left: 18px;
}

.temp-padding-top {
  padding-top: 20px;
}
</style>
